import { toBoolean } from '../../helper/boolean';

export const SYMBOL = '||';

export default function func(first: string | boolean, ...rest: (string | boolean)[]) {
    return rest.reduce<boolean>((acc, value) => acc || toBoolean(value), toBoolean(first));
}

func.SYMBOL = SYMBOL;
